import React, { useState, useContext, useEffect } from "react";
import { Link } from "gatsby";
import AdminTopBar from "../Interfaces/AdminTopBar";
import { api_handler } from "../../services/api";

import { GlobalStateContext } from "../../state/GlobalContextProvider";

const Home = (props) => {
  const themeState = useContext(GlobalStateContext);
  const [interfaces, setInterfaces] = useState([]);
  useEffect(() => {
    getInterfaces();
  }, []);



  const getInterfaces = async () => {
    var data = {};
    const api_rsp = await api_handler("int:list", data, "POST");
    setInterfaces(Array.isArray(api_rsp.data) ? api_rsp.data : []);
  };

  return (
    <div>
      <AdminTopBar pathinfo={props.path} />
      <div className="section__master">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-12 xxl:col-span-12">
            <div className="Section__body">
              <div className="intro-y box">
                <div className="pt-0 ">
                  <p className="text-center">
                    You can set up as many Interfaces as you need. You may wish
                    to have different Interfaces if you operate multiple brands.
                    Each Interface has its own unique configuration and public
                    developer portal.
                  </p>
                </div>

                <div
                  id="appContainer"
                  className="intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5"
                 >
                  {interfaces.map((iface, index) => (
                    <div className="intro-y col-span-6 sm:col-span-4 md:col-span-3 xxl:col-span-2">
                     <Link
                          to={"/interfaces/" + iface.interface_id + "/view/"}
                          iface="1234"
                          className="w-3/5 file__icon file__icon--sandbox mx-auto"
                          state={{ choice: "waffles" }}
                        > <div
                        className={
                          "interface-box box rounded-md p-5 p-3  relative zoom-in " +
                          themeState.theme
                        }
                      >
                        
                          <div className="file__icon__file-name">
                            <div className="icon_pic_large">&nbsp;</div>
                          </div>

                          <div className="iface-name text-gray-600 text-xs text-center">
                            {iface.name}
                          </div>

                          <div className="iface-url text-gray-600 text-xs text-center">
                            {iface.portal_domain}
                          </div>
                        
                      </div></Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
